import { Link, makeStyles, Typography } from "@material-ui/core"
import React, { FC } from "react"
import { colors } from "../../utils/theme"
import { LiteButton } from "./button/Button"

export const FooterHeight = 72

const useStyles = makeStyles({
  footer: {
    height: FooterHeight,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingLeft: 32,
    paddingRight: 32,
    borderTop: `1px solid ${colors.neutral.clay}`,
    backgroundColor: colors.neutral.white,
  },
  contactSupport: {
    padding: 0,
    margin: 0,
    height: 44,
    width: 136,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    backgroundColor: "transparent",
    border: `1px solid ${colors.neutral.clay}`,
    borderRadius: 4,
  },
  buttonText: {
    color: "inherit",
  },
  copyright: {
    fontFamily: "Lato",
    fontSize: 12,
    letterSpacing: 0.3,
    padding: 0,
    margin: 0,
    color: "#909CBC",
  },
  vira: {
    fontWeight: 700,
    color: colors.neutral.denim,
  },
})

const Footer: FC = () => {
  const classes = useStyles()
  return (
    <footer className={classes.footer}>
      <LiteButton>
        <Link
          href="mailto:support@ksanahealth.com"
          variant="body1"
          className={classes.buttonText}
        >
          Contact Support
        </Link>
      </LiteButton>
      <p className={classes.copyright}>
        © Copyright <span className={classes.vira}>Vira by Ksana Health</span>
      </p>
    </footer>
  )
}

export default Footer
